import { createContext } from "react";

const orderContext = createContext({
    isChanged: false,
    setIsChanged: (state) => { },
    isEdi210: 'N',
    setIsEdi210: (state) => { },
});

export default orderContext;